export const channel = 'channel';
export const channelEdition = 'channel_edition';
export const channelEditionPlaylist = 'channel_edition_playlist';
export const recommended = 'recommended';
export const series = 'series';
export const seriesSeason = 'series_season';
export const tag = 'tag';
export const userPlaylist = 'user_playlist';
